window.CashtillStats = {
	
	charts : [],
	
	prepareFilterForm: function(tillid){
		var options = {success:function(data){CashtillStats.processFilterForm(data);}, dataType:"json"};
		MyForm.prepare("cashtillstatsFilterForm", "pos_cashtills&action=stats_updateListing&tillid="+tillid, options);
		CashtillStats.initListingGraph();
	},
	
	processFilterForm: function(data){
		Listing.refresh("cashtillstatsListing", data, data.cashtillstats_metadatas);
		CashtillStats.initListingGraph();
	},
	
	initListingGraph: function(){
		
		$('.stats_graph div[e_autograph]').each(function(){
			
			var json = $.parseJSON($(this).attr('graph_data'));
			var seriesData	= [];
			var columns = [];
			
			$.each(json, function(index, value){
				columns.push(value.name);
				seriesData.push(value);
			});
			
			var chart = $(this).highcharts({
				chart: {
					type: 'column',
                    backgroundColor: "transparent",
				},
				title: {
					text: '',
					align: 'center',
					verticalAlign: 'top'
				},
				xAxis: {
					categories: columns,
					crosshair: true
				},
				yAxis: {
					min: 0,
					title: {
						text: ''
					}
				},
				tooltip: {
					useHTML: true,
					positioner: function () {
						return { x: 0, y: 10 };
					},
					borderWidth: 0,
					shadow: false,
				},
				plotOptions: {
					column: {
						pointPadding: 0.2,
						borderWidth: 0
					}
				},
				credits: {
					enabled: false
				},
				series: seriesData,
			});
			
			CashtillStats.charts.push(chart);
		});
		
	}
	
};

/* global MyForm, Utils, MyFacture, Loc, MyWindow, Listing, SellsyError */
window.Pos = {
	
	buyOrToggleLicenceStatus: function(canal, tillid, licenceid){
	
		var winOptions = {
				resizable	: false,
				type		: 'error',
				title		: Loc.g("Cette licence n’est pas active"),
				width		: 500,
				buttons		: [
                    {
						text : Loc.g("Fermer"), 
						click : function(){
							$(this).dialog("close");
						}
					},
                    {
						text : Loc.g("Acheter la licence"), 
						click : function(){
							MyWindow.close('alertWindow');
                            Subscription.upsellRequest('licence', 'pos', false);
                        }
					},
                    {
						text : Loc.g("Enlever la licence"), click : function(){
							Pos.toggleLicenceStatus(tillid);
						}
					}
				]
			};

		var msg = Loc.g("Cette licence n'est pas active car en essai ou bloquée.") + "<br /><br />" + Loc.g('Que voulez-vous faire ?');
		MyWindow.alert(msg, winOptions);
		
	},
	
	toggleLicenceStatus: function(tillid){
	
		var options = {
			resizable	: false,
			type		: 'warning',
			title		: Loc.g("Attention"),
			buttons		: [
                {text : Loc.g("Non"), click : function(){$(this).dialog("close");}},
                {text : Loc.g("Oui"), click : function(){Pos.do_toggleLicenceStatus(tillid);$(this).dialog("close");}}
			]
		};
		
		MyWindow.alert(Loc.g('Attention, vous êtes sur le point de modifier la licence de cette caisse. Voulez-vous continuer ?'), options);
		
	},
	
	do_toggleLicenceStatus: function(tillid){
		
		var options = {action:"toggleLicenceStatus", tillid:tillid};
		
		MyFacture.post("pos_cashtills", options, function(data){
			
			if (data.response.status === 'ok'){
				Listing.update('cashtillsListing');
			} else {
				
				var winOptions = {
					resizable	: false,
					type		: 'error',
					title		: Loc.g("Erreur"),
					buttons		: [
						{text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}}
					]
				};
				
				switch (data.response.error){
					
					case 'admin':
						var msg = Loc.g("Vous ne disposez pas des privilèges nécessaire pour gérer les licences.");
						break;
						
					case 'trial':
						var msg = Loc.g("Vous ne pouvez pas désactiver une licence en essai gratuit.");
						break;
						
					case "buy":
						var msg = Loc.g("Vous ne disposez plus de licence de caisse disponbile. Vous pouvez désactiver des licences utilisées ou en acheter de nouvelles.");
						
						winOptions.buttons =  [
                            {text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}},
                            {text : Loc.g("Acheter des licences"), click : function(){
                                    Subscription.upsellRequest('licence', 'pos', false);
									MyWindow.close('alertWindow');
								}
							}
						];
						
						break;
				}
				
				MyWindow.alert(msg, winOptions);
			}
			
		}, "json");
	},
	
	initPrefsGeneral : function(){
		$('#prefsMenu').height($('#contentDiv').outerHeight());
		var formId = "posprefForm";
		var options = {
			success:function(data){
				var formIsOk = MyForm.processJson(data, "posprefForm");
				if(formIsOk){
					MyWindow.alert(Loc.g('Vos informations ont bien été mises à jour.')+Loc.g(' Re-synchronisez vos caisses pour prendre en compte ces nouveaux réglages'), {type: 'confirm'});
				}
			},
			dataType:"json"
		};
		MyForm.prepare(formId, "pos_prefs&action=generalRecord", options, false);
		MyFacture.customForm();
		
		$('select[name*=pospref_counter]').bind('change', function(){Pos.updateNum();});
		$('input[name*=pospref_counter]').bind('keyup', function(){Pos.updateNum();});
	},
			
			
	updateNum : function(){
		var style = $('select[name=pospref_counterFormat]').val();
		var root = $('input[name=pospref_counterPrefix]').val();
		var glue = $('select[name=pospref_counterSeparator]').find('option:selected').attr('glue');

		var dateformat = $('select[name=pospref_counterDate]').val();
		var counter = $('input[name=pospref_counterNumber]').val();
		
		while (counter.length < 5){
			counter = '0'+counter;
		}
		
		var date = new Date();
		var day = date.getDay() < 10 ? '0'+date.getDay(): ''+date.getDay();
		var month = (date.getMonth()+1) < 10 ? '0'+(date.getMonth()+1) : ''+(date.getMonth()+1);
		var year = ''+date.getYear();
		var fullYear = ''+date.getFullYear();
		
		var dateForExample = '';
		
		switch(dateformat){
			case 'Ymd':dateForExample = fullYear+day+month;break; 
			case 'dmY':dateForExample = day+month+fullYear;break; 
			case 'mdY':dateForExample = month+day+fullYear;break; 
			case 'Ym':dateForExample = fullYear+month;break; 
			case 'Y':dateForExample = fullYear;break; 
			case 'yym':dateForExample = year+month;break; 
			case 'yymd':dateForExample = year+month+day;break; 
		}
		
		
		var identFormatForExample = new Array();
		switch (style){
			case  'rootdatenum':
				identFormatForExample = [root, dateForExample, counter];
			break;
			case  'rootnumdate':
				identFormatForExample = [root, counter, dateForExample];
			break;
			case  'daterootnum':
				identFormatForExample = [dateForExample, root, counter];
			break;
			case  'datenumroot':
				identFormatForExample = [dateForExample, counter, root];
			break;
		}
		$('#counterSample').val(identFormatForExample.join(glue));
	}
};



window.CashTill = {
	
	inputNamePrefix : 'till_',
	
	updateNum : function(){
		var style = $('select[name=till_counterFormat]').val();
		var root = $('input[name=till_counterPrefix]').val();
		var glue = $('select[name=till_counterGlue]').find('option:selected').attr('glue');

		var dateformat = $('select[name=till_counterDate]').val();
		var counter = $('input[name=till_counterNumber]').val();
		
		while (counter.length < 5){
			counter = '0'+counter;
		}
		
		var date = new Date();
		var day = date.getDay() < 10 ? '0'+date.getDay(): ''+date.getDay();
		var month = (date.getMonth()+1) < 10 ? '0'+(date.getMonth()+1) : ''+(date.getMonth()+1);
		var year = ''+date.getYear();
		var fullYear = ''+date.getFullYear();
		
		var dateForExample = '';
		
		switch(dateformat){
			case 'Ymd':dateForExample = fullYear+day+month;break; 
			case 'dmY':dateForExample = day+month+fullYear;break; 
			case 'mdY':dateForExample = month+day+fullYear;break; 
			case 'Ym':dateForExample = fullYear+month;break; 
			case 'Y':dateForExample = fullYear;break; 
			case 'yym':dateForExample = year+month;break; 
			case 'yymd':dateForExample = year+month+day;break; 
		}
		
		
		var identFormatForExample = new Array();
		switch (style){
			case  'rootdatenum':
				identFormatForExample = [root, dateForExample, counter];
			break;
			case  'rootnumdate':
				identFormatForExample = [root, counter, dateForExample];
			break;
			case  'daterootnum':
				identFormatForExample = [dateForExample, root, counter];
			break;
			case  'datenumroot':
				identFormatForExample = [dateForExample, counter, root];
			break;
		}
		$('#counterSample').val(identFormatForExample.join(glue));
	},
	
	editForm : function(tillid){
		tillid = tillid === undefined ? '' : tillid;
		var options = {
			title	: Loc.g("Nouvelle caisse"),
			buttons	: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close")}},
                {text : Loc.g("Enregistrer"), click : function(){$("#cashtillForm").submit();}}
			],
			width:880,
			callback	: function(){
				var options = {
					success:function(data){
						MyForm.processJson(data, "opportunityForm");
						if(data.form.status === 'ok'){
							Utils.relocate('./?_f=pos_cashtills&action=overview&tillid='+data.tillid);
						}
					}, 
					dataType:"json"};

				$("input[type=checkbox]").bind('change', function(){
					if($(this).attr('syscode') === 'cb' || $(this).attr('syscode') === 'cash'){
						MyWindow.alert(Loc.g('Ce moyen de paiement doit obligatoirement être sélectionné'), {type : 'warning'});
						$(this).prop('checked', true);
					}
				});
				var params = {'action': 'record'};
				MyForm.prepare("cashtillForm", "pos_cashtills&"+$.param(params), options, true);
				MyFacture.customForm();
				
			}
		};
		MyWindow.load('pos_cashtills', {action:"cashtillForm", tillid : tillid}, options);
	},
	
	prepareEditForm : function(){
		
		var _this					= this;
		var $payMediumsContainer	= $('.pos_paymediumsContainer');
		
		var options = {
			
			success : function(data){
				
				MyForm.processJson(data, "cashtillForm");
				
				for(var i in data.form.fields){
					
					if(data.form.fields[i].fieldId === 'till_paymediums'){
						
						$('.alert', $payMediumsContainer).remove();
						$payMediumsContainer.prepend('<div class="alert alert-danger">'+data.form.fields[i].msg+'</div>');
						
					}
					
				}
				
				if(data.form.status === 'ok'){
					if(data.licencestatus === 'ok'){
						Utils.relocate('./?_f=pos_cashtills&action=overview&tillid='+data.tillid);
					}else{
						Utils.relocate('./?_f=pos_cashtills&action=cashtills');
					}
				}
				
			}, 
			dataType : "json"
		};

		MyForm.prepare("cashtillForm", "pos_cashtills&" + $.param({ action : 'record'}), options, true);
		MyFacture.customForm();

		$('.counter select').bind('change', CashTill.updateNum.bind(this));
		$('.counter input').bind('keyup', CashTill.updateNum.bind(this));
		
		CashTill.updateNum();
		
		$("input[type=checkbox]", $payMediumsContainer).off('click').on('click', function(event){
			$('.pos_paymediumsContainer .alert').remove();
		});
		
		$("input[type=checkbox][syscode=cb], .pos_paymediumsContainer input[type=checkbox][syscode=cash]", $payMediumsContainer).off('click').on('click', function(){
			
			var $this = $(this);
			
			if(!$this.prop('checked')){
				$this.prop('checked', true);
			}
			
		});
		
		$("input[name='" + this.inputNamePrefix + "hasRateCategory']").on('change', function(){
			_this.checkRateCategories.apply(_this, [true]);
		});
		$("select[name='" + this.inputNamePrefix + "currencyid']").on('change', function(){
			
			var $currencyID				= $(this);
			var $rateCategory			= $("select[name='" + _this.inputNamePrefix + "rateCategory']");
			var previousRateCategory	= $rateCategory.val();
			
			MyFacture.post(
				'pos_cashtills',
				
				{
					action		: 'getAvailableRateCategories',
					tillID		: $("input[name='" + _this.inputNamePrefix + "id']").val(),
					currencyID	: $currencyID.val()
				},
				
				function(response){
					
					var rateCategories	= response.rateCategories;
					var optionTemplate	= _.template('<option value="<%= id %>"><%= name %></option>');
					var optionHTML		= '';
					
					_.each(rateCategories, function(rateCategory){
						optionHTML += optionTemplate(rateCategory);
					});
					
					$rateCategory.empty();
					$rateCategory.append(optionHTML);
					
					$('option[value=' + previousRateCategory + ']', $rateCategory).prop('selected', true);
					_this.checkRateCategories(false, true);
					
				},
				
				'json'
			);
			
		});
		
	},
	
	checkRateCategories : function(toggleRateCategory, triggerChange){
		
		triggerChange			= !_.isUndefined(triggerChange) ? triggerChange : false;
		var $hasRateCategory	= $("input[name='" + this.inputNamePrefix + "hasRateCategory']");
		var $rateCategory		= $("select[name='" + this.inputNamePrefix + "rateCategory']");
		
		if($hasRateCategory.prop('checked') === true){
				
			if($('option', $rateCategory).length === 0){
				
				toggleRateCategory = false;
				$hasRateCategory.prop('checked', false);
				
				if(triggerChange){
					$hasRateCategory.change();
				}else{
					
					MyWindow.alert(Loc.g("Impossible d‘activer les catégories tarifaires car aucune d‘entre elles n‘est disponible pour la devise sélectionnée") + '.', {
						type : 'error'
					});
					
				}
				
			}

		}
		
		if(toggleRateCategory === true){
			$rateCategory.closest('.form-group').toggleClass('hidden');
		}
		
	},
	
	prepareFilterForm: function(){
        var options = {success:function(data){CashTill.processFilterForm(data);}, dataType:"json"};
        MyForm.prepare("cashtillsFilterForm", "pos_cashtills&action=updateListing", options);
    },
	
	processFilterForm: function(data){
		Listing.refresh("cashtillsListing", data, data.cashtills_metadatas);		
	},
	
	enable : function(canal, tillID){ 
        if(!Utils.exists("till_"+tillID)){
            return false;
		}
		
        var datas = {
			'action': "enableCashtill", 
			'tillid' : tillID
		};
		
        MyFacture.post("pos_cashtills", datas, function(data){
			if (data.errno === 0){
				Utils.reload();
			}else{
                Subscription.renewRequest('licence', 'pos', data.licenceID);
			}
		}, "json");
        return true;
    },
	
	initOverview : function(){
		var tillID = $('#cashTillOverview').attr('tillid');
		
		if ($('#sessions').length > 0){
			$("#sessions .nano").debounce("scrollend", function(e){
				var trigg = $('#sessions .moreBtn a');
				if (!trigg.hasClass('stop') && trigg.is(':visible')){
					$('#sessions .moreBtn a').trigger('click');
					$('#sessions .nano').nanoScroller({preventPageScrolling: true});	
				}
			});

			$('#sessions .noSession').remove();
			CashTill.getSessions();
		}
		
		$('.tillSession').on('click', function(){
			$('.tillSession:not(#'+$(this).attr('id')+')').removeClass('active');
			$(this).addClass('active');
		});
		
		$('form[name=logoModeForm] input:radio').on('change', function(){
			$('.receiptLogo:not(#'+$(this).val()+'Logo)').hide();
			$('#'+$(this).val()+'Logo').show();
			
			if($(this).val() === 'till'){
				$('.logo-uploader').show();
			}else{
				$('.logo-uploader').hide();
			}
			
			MyFacture.post('pos_cashtills', {action : "changeLogoMode", tillid : tillID, logoMode : $(this).val()});
		});
		
		Statistics.init();
		Statistics.triggerFilterForm();
	},
			
			
	getStatistics: function(){
		var tillid = $('#cashTillOverview').attr('tillid');
		MyFacture.post('pos_cashtills', {tillid : tillid, action : "stats"},
			function(data){
			},
			'json');
		
	},
			
	getOfflineTills : function(){
		
		var alertsContainer = $('#posAlertPopUp', '.alertHeaderContainer');
		
		if(alertsContainer.hasClass('notifOpen')){
			alertsContainer.hide().removeClass('notifOpen');
		}else{
			
			MyFacture.post("pos_cashtills", {action : "offlineTills"}, function(data){
				
				var nbTills = data.nbOfflineTills;
				var counter = $('.qtip #nbPosOffline');
				
				counter.html(nbTills);
				
				if(nbTills > 0){
					counter.removeClass('spanLabel-green').addClass('spanLabel-orange');
					alertsContainer.show().addClass('notifOpen');
					$('.notifTable tbody', alertsContainer).html(data.pos_cashtillsAlerts);
				}else{
					counter.removeClass('spanLabel-orange').addClass('spanLabel-green');
				}
				
			}, "json");
			
		}
			
	},
			
	getSessions : function(){
		var moreBtn = $('#sessions .moreBtn a');
		if (!moreBtn.hasClass('stop')){
			// Type specifies which EventList to load : dashboard, third, invoice, estimate, creditnote...
			var params = new Object;
			params.tillid = $('#sessions ul').attr('tillid');
			
			params.page = parseInt($('#sessions ul').attr('page'), 10)+1;
			params.action = 'loadSessions';
			moreBtn.addClass('stop');
			MyFacture.beLoading(moreBtn);
			MyFacture.post('pos_cashtills',params, function(data){
				if (data){
					$('#sessions ul').append(data.eventListing);
					var currentPage = parseInt($('#sessions ul').attr('page'), 10)+1;
					$('#sessions ul').attr('page', currentPage);

					if (data.newPageNbEvents === 0){
						$('#sessions .moreBtn').hide();
					}

					$('#sessions .moreBtn a').removeClass('stop');
					MyFacture.beLoading($('#sessions .moreBtn a'));
				}

				$('#sessions .nano').nanoScroller({preventPageScrolling: true});
			}, 'json' );		
		}
		
	},
	loadReceipts : function(tillid, sessid){
		$('#receiptsMiniListing_filter_sessid').val(sessid);
		$('#receiptsMiniListing_filter_tillid').val(tillid);
		$('.tillSession').removeClass('active');
		$('#session_'+sessid).addClass('active');
		Listing.update('receiptsMiniListing', true);
		
			var params = new Object;
			params.tillid = tillid;
			params.sessid = sessid;
			params.action = 'loadSession';
			MyFacture.post('pos_cashtills',params, function(data){
				$('#sessionDetails .nanoScrollbarContent').html(data.html);
				$('#sessions .nano').nanoScroller({preventPageScrolling: true});
			}, 'json' );
	},
			
			
	deleteIt : function(tillID){
		var options = {
			resizable	: false,
			noclose		: true,
			type		: 'error',
			title		: "Suppression d'une caisse",
			buttons		: [
                {text : Loc.g("Non"), click : function(){$(this).dialog("close");}},
                {text :
					Loc.g("Oui"),
					click : function(){
						var datas = {'action':"delete", 'tillid' : tillID};
						MyFacture.post("pos_cashtills", datas, function(data){Utils.reload();}, "json");
						return true;
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Supprimer cette caisse ?"), options);
	},
	
	addSeller : function(item){
		$('#'+item.id+'_details').removeClass('hidden');
		MyFacture.customForm();
	},
	removeSeller : function(item){
		$('#'+item.id+'_details').addClass('hidden');
	},
			
	updateLogoPreview : function(data){
		$('#tillLogo').html('<img src="'+data.file+'" />');
	},
	
	openConfirmAutologPopup : function(step, id){
		
		if(step === 'closed'){
			this.autoLog(id);
		}else{
			
			MyWindow.alert(Loc.g("Une session est actuellement en cours sur cette caisse") + ".<br><br>" + Loc.g("Si cette denière est déjà ouverte sur une autre machine, celle-ci se verra déconnectée et vous risquez de perdre votre travail en cours") + ".", {
				type	: 'warning',
				buttons : [
                    { text : Loc.g('Annuler'),		click : function(){$(this).dialog("close");} },
                    { text : Loc.g('Accepter et se connecter'), click : $.proxy(function(){this.autoLog(id);}, this) }
				]
			});
			
		}
		
	},
	
	autoLog : function(cashtillId){
		
		var toRedirect = false;
		var redirectUrl = '';
		
		/**
		 * Not async request
		 * Impossible to open new link in tab if you didn't do it in click handler
		 * I tried to call a method with click event context
		 * Tried to call deferred object with same context
		 * But Nothing work (cf http://stackoverflow.com/a/13158856 )
		 * That's why I didn't use MyFacture.post
		 */
		$.ajax({
			url : MyFacture.buildUrl('pos_cashtills'),
			type: 'POST',
			async : false,
			dataType : 'json',
			data : {
				action		: 'autoLog',
				cashtillId	: cashtillId
			},
			
			success : function(back){
				
				var success = back['success'];
			
				if(typeof(success['token']) == 'undefined'){

					var errorMsg = Loc.g("Impossible de se connecter") + "<br />";

					switch(success['error']){
						case 'licence':
							errorMsg += Loc.g("La caisse sur laquelle vous souhaitez vous connecter ne possède pas une licence valide");
							break;
						case 'staff':
							errorMsg += Loc.g("Vous n'êtes pas autorisés à utiliser cette caisse");
							break;
						default:
							errorMsg += Loc.g("Une erreur s'est produite lors de l'authentification");
							break;
					}

					MyWindow.alert(errorMsg, {type : 'warning'});

				}else{

					toRedirect = true;
					redirectUrl = success['url'] + '/index.php?autolog=Y&oauth_token=' + success['token'] + '&oauth_secret=' + success['secret'];
					
					MyWindow.alert(Loc.g("Dans quelques instants vous allez être redirigé vers votre interface de caisse") + "<br /> <img src='/ressources/logged/img/common/loader.gif' style='margin: 10px 42%;'> <br />" + Loc.g("Si rien ne se passe") + " <a style='color:#229EE6;font-weight:bold' href='" + redirectUrl + "'> " + Loc.g("cliquer ici") + "</a> ", {type:'confirm'});
					
					setTimeout(function() {
						MyWindow.close('alertWindow');
					}, 4000);

				}
			}
		});
		
		if(toRedirect){
			window.open(redirectUrl);
		}
		
	}
};


window.Receipt = {
	
	thirdLinkInputNamePrefix : 'receipt_',
	
	prepareFilterForm: function(){
        var options = {success:function(data){Receipt.processFilterForm(data);}, dataType:"json"};
        MyForm.prepare("receiptsFilterForm", "pos_receipts&action=updateListing", options);
    },
	
	processFilterForm: function(data){
		Listing.refresh("receiptsListing", data, data.receipts_metadatas);		
	},
			
	prepareMiniFilterForm: function(){
        var options = {success:function(data){Receipt.processMiniFilterForm(data);}, dataType:"json"};
        MyForm.prepare("receiptsMiniFilterForm", "pos_receipts&action=updateMiniListing", options);
    },
	
	processMiniFilterForm: function(data){
		Listing.refresh("receiptsMiniListing", data, data.receiptsMini_metadatas);		
	},
	
	/**
	 * Open the receipt overview into a popup
	 * @param {int} receiptID
	 */
	view : function(receiptID){
		
		var _this = this;
		
		MyWindow.load('pos_receipts',
			{
				action		: "overview",
				receiptID	: receiptID
			},
			{
				title		: Loc.g('Ticket'),
				buttons		: [
                    {
                        text	: Loc.g('Fermer'),
                        click	: function(){
                            $(this).dialog('close');
                        }
                    },
                    {
						text	: Loc.g('Imprimer'),
						class	: "btn btn-primary",
						click	: function(){
							_this.print(receiptID);
						}
					}
				],
				width		: 400,
				callback	: function(){}
			}
		);
	
	},
	
	/**
	 * Prepare and print a receipt
	 * @param {int} receiptID
	 */
	print : function(receiptID){
		
		var _this = this;
		
		MyFacture.post('pos_receipts',
			{
				action		: 'overview',
				receiptID	: receiptID
			},
			
			function(receiptHTML){
				var $printBlock = $('#print-block');

				$printBlock.html(receiptHTML);
				
				// If img found, we have to wait load event to be enable to print them
				var $img = $('img', $printBlock);
				if($img.length > 0){
					
					$img.on('load', function(){
						_this.printProcess($printBlock);
					});
					
				}else{
					_this.printProcess($printBlock);
				}
				
			}
		);
		
	},
	
	/**
	 * Common process for receipt printing
	 * @param {jQuery} $printBlock
	 */
	printProcess : function($printBlock){
		
		var $toHide = $('.global, .ui-widget-overlay, .ui-dialog');
		
		$toHide.addClass('hidden-print');
		window.print();
        $printBlock.html('');
		$toHide.removeClass('hidden-print');
		
	},
	
	/**
	 * Load and open third link popup
	 * @param {int} receiptID
	 */
	openThirdLinkPopup : function(receiptID){
		
		var inputNamePrefix = this.thirdLinkInputNamePrefix;
		var formID			= 'thirdLinkForm';
		
		MyWindow.load('pos_receipts',
			{
				action		: "loadThirdLinkForm",
				receiptID	: receiptID
			},
			{
				title		: Loc.g('Modifier la liaison client'),
				buttons		: [
                    {
                        text	: Loc.g('Fermer'),
                        click	: function(){
                            $(this).dialog('close');
                        }
                    },
                    {
						text	: Loc.g('Envoyer par email'),
						click	: function(){

							$('#' + inputNamePrefix + 'sendByEmail').val('Y');
							$('#' + formID).submit();

						}
					},
                    {
						text	: Loc.g('Enregistrer'),
						click	: function(){

							$('#' + inputNamePrefix + 'sendByEmail').val('N');
							$('#' + formID).submit();

						}
					}
				],
				width		: 515,
				callback	: function(){
					
					MyForm.prepare(formID, 'pos_receipts', {
						
						dataType	: 'json',
						data		: {
							action		: 'recordThirdLink'
						},
						
						success		: function(data){
							
							if(MyForm.processJson(data, formID)){
								Utils.reload();
							}
							
						}
						
					}, true);
					
					MyFacture.customForm();
					
				}
			}
		);
		
	},
	
	/**
	 * Binded on adding a third link from the third link token input
	 * @param {Object} third
	 */
	onAddThirdLink : function(third){
		$('#' + this.thirdLinkInputNamePrefix + 'email').val(third.email);
	},
	
	/**
	 * Binded on deleting a third link from the third link token input
	 */
	onDeleteThirdLink : function(){
		$('#' + this.thirdLinkInputNamePrefix + 'email').val('');
	}
	
};

var CashTillMove = {
	prepareFilterForm: function(){
        var options = {success:function(data){CashTillMove.processFilterForm(data);}, dataType:"json"};
        MyForm.prepare("cashtillmovesFilterForm", "pos_moves&action=updateListing", options);
    },
	
	processFilterForm: function(data){
		Listing.refresh("cashtillmovesListing", data, data.cashtillmoves_metadatas);		
	}
};
